<template>

<com-item name="collection.overview" :no-hover="true" :is-overview="3" size="1" >

	<template v-slot:stats>

		<com-overview 
			label="Years Running" 
			type="number" 
			:value="6" 
		/>

		<com-overview 
			label="Updates" 
			type="number" 
			:value="65" 
		/>

		<com-overview 
			label="Cloud Servers" 
			type="number" 
			:value="7" 
		/>

		<com-overview 
			label="Usernames" 
			type="number" 
			:value="data.usernames" 
		/>

		<com-overview 
			label="Registered Users" 
			type="number" 
			:value="data.registered" 
		/>

		<com-overview 
			label="Groups" 
			type="number" 
			:value="data.groups" 
		/>

		<com-overview 
			label="Owned Games" 
			type="number" 
			:value="data.games" 
		/>

		<com-overview 
			label="Ratings" 
			type="number" 
			:value="data.ratings" 
		/>

		<com-overview 
			label="Plays" 
			type="number" 
			:value="data.plays" 
		/>

	</template>

</com-item>

</template>

<script>
import comItem from './../../profile/insights/common/Item'
import comOverview from './../../profile/insights/common/Overview'

export default {

	props: ['data'],

	components: {
		'com-item': comItem,
		'com-overview': comOverview
	}

}

</script>

<style scoped>

</style>